module.exports = __webpack_public_path__ + "static/media/sitio.3fb3f6a8.PNG";